import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Images } from '../../../global/GloblImages.tsx'
import { ApiUsersLogin } from '../../../apiService/Core/Apicall.tsx'
import { roleRedirects } from '../../../global/constants/roleRedirects.tsx'
import { fetchClientList } from '../../../global/config/Reducer/clientSlice.ts'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../global/config/store.ts'
import { toast, ToastContainer } from 'react-toastify'

interface LoginErrors {
  username: string
  password: string
}
const Login: React.FC = () => {
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [callApi, setCallApi] = useState<boolean>(false)
  const dispatch = useDispatch<AppDispatch>();
  const { clientList, loading, error } = useSelector((state: RootState) => state.client);
  const [showportalName, setShowPortalName] = useState<React.ReactNode>(null);

  const [errors, setErrors] = useState<LoginErrors>({
    username: '',
    password: ''
  })
  const icons: any = Images()
  const navigate = useNavigate()

  useEffect(() => {
    if (callApi) {
      dispatch(fetchClientList());
    }
  }, [dispatch, callApi]);

  const handleLogin = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()

    const loginData: any = {
      emailId: username,
      password: password
    }
    const newErrors: LoginErrors = { username: '', password: '' }
    if (!username) newErrors.username = 'Please enter username'
    if (!password) newErrors.password = 'Please enter password'
    if (newErrors.username || newErrors.password) {
      setErrors(newErrors)
      return
    }
    try {
      const response: any = await ApiUsersLogin(loginData)
      if (response?.requiresTwoFactor) {
        if (response?.roleName === "admin" || response?.roleName === "superadmin" || response?.roleName === "editor") {
          navigate("/verify", {
            state: {
              username,
              password,
              tempToken: response?.tempToken,
            },
          });
        } else if (response?.roleName === "shopper") {
          toast.error("Invalid Access");
          setShowPortalName(
            <div>
              Please Login to{" "}
              <a
                href={process.env.REACT_APP_SHOPPER_SITE}
                target="_blank"
                rel="noopener noreferrer"
              >
                Shopper Portal
              </a>
            </div>
          );
        } else if (response?.roleName === "clientadmin" || response?.roleName === "areaManager" || response?.roleName === "venueadmin") {
          toast.error("Invalid Access");
          setShowPortalName(
            <div>
              Please Login to{" "}
              <a
                href={process.env.REACT_APP_MM_CLIENT_SITE}
                target="_blank"
                rel="noopener noreferrer"
              >
                Client Portal
              </a>
            </div>
          );
        }
        else {
          toast.error("Invalid Access")
        }
      }
      else if (response?.userDetails) {
        setCallApi(true)
        const user = response.userDetails
        if (["1", "2", "3"].includes(String(user.role.roleId))) {
          localStorage.setItem('userRole', user.role.roleId)
          localStorage.setItem('userId', user.userId)
          localStorage.setItem('userStatusId', user.userStatus.userStatusId)
          localStorage.setItem('createdBy', user.userId)
          localStorage.setItem('user', user)
          localStorage.setItem('userName', user.displayName)
          localStorage.setItem('userRoleName', user.role.roleDisplayName)
          localStorage.setItem('useremail', user.emailId)
          // localStorage.setItem('editorId', user)
          localStorage.setItem('token', response.token)
          // const redirectUrl = roleRedirects[user.role.roleId] || '/login'
          // console.log(redirectUrl);
          // navigate(redirectUrl)

          const redirectUrl = roleRedirects[user.role.roleId] || '/login'
          navigate(redirectUrl)
        }
        else {
          toast.error("Invalid Access")
          navigate('/login')
        }
      } else {
        setErrors({ ...newErrors, username: 'Invalid username or password' })
      }
    } catch (error) {
      console.error('Error during API call:', error)
      setErrors({
        ...newErrors,
        username: error
      })
    }
  }
  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement>,
    setter: React.Dispatch<React.SetStateAction<string>>
  ): void => {
    setter(e.target.value)
  }
  return (
    <div
      className='login-banner'
      style={{
        backgroundImage: `url(${icons.LoginBanner})`
      }}
    >
      <ToastContainer />
      <form onSubmit={handleLogin} id='formLogin'>
        <div className='row'>
          <div
            className='col-lg-4 col-md-4 col-sm-12 offset-sm-0 offset-lg-4 p-sm-5'
            style={{ margin: 'auto' }}
          >
            <div className='team-item p-lg-5 p-sm-3'>
              <div style={{ textAlign: 'center' }}>
                <img src={icons.mmLogo} width={'50%'} alt='Mystery Management' />
              </div>
              <div className='team-content'>
                <br />
                <h3 className='box-title m-b-20 text-center'>Sign In</h3>
                <br />
                <div className='form-group'>
                  <div className='col-xs-12'>
                    <input
                      name='txtUN'
                      type='text'
                      id='txtUN'
                      className='form-control'
                      placeholder='Email'
                      value={username}
                      onChange={e => handleInputChange(e, setUsername)}
                    />
                    {errors.username && (
                      <span className='text-danger'>{errors.username}</span>
                    )}
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-xs-12'>
                    <input
                      name='txtPass'
                      type='password'
                      id='txtPass'
                      className='form-control'
                      placeholder='Password'
                      value={password}
                      onChange={e => handleInputChange(e, setPassword)}
                    />
                    {errors.password && (
                      <span className='text-danger'>{errors.password}</span>
                    )}
                  </div>
                </div>
                <div className='my-2'>{showportalName}</div>
                <div className='form-group text-center m-t-20'>
                  <div className='col-xs-12'>
                    <button
                      type='submit'
                      style={{ background: 'linear-gradient(175deg, #ccd3b4 4.38%, #607438 111.49%)', color: "white" }}
                      className='btn  btn-lg btn-block text-uppercase waves-effect waves-light mb-0'
                    >
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
export default Login
